$(function ($) {
  $(".lesson-module-wrap.quiz").each(function (i, el) {
    var $module = $(el);
    var $questions = $module.find(".quiz-question-wrap");
    var $prevQuestion = $module.find(".quiz-prev-question");
    var $nextQuestion = $module.find(".quiz-next-question");
    var $checkQuestion = $module.find(".quiz-check-question");
    var $continue = $module.find(".quiz-continue");

    var curQuestionIndex = false;
    var $curQuestion = false;

    function setCurrentQuestion(ind) {
      if (curQuestionIndex !== false) {
        $curQuestion.removeClass("active");
      }

      curQuestionIndex = ind;
      $curQuestion = $(".quiz-question-wrap.question-" + ind);
      $curQuestion.addClass("active");

      if (ind == 0) $prevQuestion.hide();
      else $prevQuestion.show();

      $checkQuestion.show();
      $nextQuestion.hide();
      $continue.hide();
    }

    function nextQuestion(isNext) {
      var dir = isNext ? 1 : -1;
      setCurrentQuestion(curQuestionIndex + dir);
    }

    function answerQuestion() {
      var correctAnswersString = "" + $curQuestion.data("ans");
      var correctAnswers = correctAnswersString.split(",").map(function (val) {
        return parseInt(val);
      });

      $checkQuestion.hide();

      $curQuestion.find(".quiz-choice").each(function (i, choice) {
        var $choice = $(choice);
        var $input = $choice.find("input");
        var val = parseInt($input.val());

        // mark incorrect
        if ($input.is(":checked")) $choice.addClass("selected");

        if ($.inArray(val, correctAnswers) == -1)
          $choice.addClass("incorrect-answer");

        // mark correct
        if ($.inArray(val, correctAnswers) > -1)
          $choice.addClass("correct-answer");
      });

      var $explanation = $curQuestion.find(".quiz-explanation");
      $explanation.show();

      // enable nav
      if (curQuestionIndex < $questions.length - 1) $nextQuestion.show();
      else {
        $nextQuestion.hide();
        $continue.show();
      }
    }

    $checkQuestion.on("click", answerQuestion);
    $prevQuestion.on("click", function (e) {
      nextQuestion(false);
    });
    $nextQuestion.on("click", function (e) {
      nextQuestion(true);
    });
    $continue.on("click", function () {
      window.posiNextModule(true);
    });

    setCurrentQuestion(0);
  });
});
